import React from 'react';

import { useTranslation, Trans } from "react-i18next";

import Fade from 'react-reveal/Fade'

import { Link } from "react-router-dom"

function MeshThick () {

    const { t } = useTranslation();

    const data = [
        { t1: "4", t2: "8" },
        { t1: "6", t2: "10" },
        { t1: "8", t2: "12" },
        { t1: "10", t2: "14" },
    ];
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto">
                <div className="flex flex-col xl:flex-row justify-between">
                    <div className='flex flex-col'>
                        <p className="text-[28px] xl:text-[45px] open-sans text-[#F26522] leading-[1.4] xl:max-w-[347px] text-center xl:text-start">
                            <Trans>{t("mansorymesh.9")}</Trans>
                        </p>
                        <Link to="/form" className='mr-auto hidden xl:block'>
                            <div className="contactus mt-[40px] hidden xl:block hover:scale-[1.1] transition-all">
                                <p className="text-[#1D1D1D] montserrat font-[600] text-[14px] xl:text-[16px]">{t('CompositeReinforcement.5')}</p>
                            </div>
                        </Link>
                    </div>
                    <div className='xl:w-[calc(50%-20px)] mt-[35px] xl:mt-0'>
                        <table className="min-w-full border-separate border-spacing-y-[4px] relative overflow-hidden">
                            <thead className="bg-[#F26522] open-sans text-[#1D1D1D] text-[12px] xl:text-[20px]">
                                <tr>
                                    <th className="p-[8px] md:p-[15px] text-left font-[600] md:font-[300]">
                                        {t("mansorymesh.10")}
                                    </th>
                                    <th className="p-[15px] text-left font-[600] md:font-[300]">
                                        {t("mansorymesh.11")}
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="">
                                {data.map((item, index) => (
                                    <Fade bottom delay={index * 150} key={item.type}>
                                        <tr>
                                            <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                                {t(item.t1)}
                                            </td>
                                            <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                                {t(item.t2)}
                                            </td>
                                        </tr>
                                    </Fade>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>    
            </div>
        </div>
    );
}

export default MeshThick;